import { MenuUserConfigModel } from "@core/models/outros/menu-user-config.model";

export const MENU_USER_DATA_CONSTANT: MenuUserConfigModel[] = [
  {
    id: 1,
    route: '/home',
    icon: 'home',
    description: 'Home',
    hash: 'dev',
    onlyAssociated: false
  },
  {
    id: 2,
    route: '/configuracoes-de-usuarios/meus-dados',
    icon: 'account_circle',
    description: 'Meus Dados',
    hash: 'dev',
    onlyAssociated: false
  },
  {
    id: 3,
    route: '/configuracoes-de-usuarios/meus-dados/alterar-senha',
    icon: 'pin',
    description: 'Alterar Senha',
    hash: 'dev',
    onlyAssociated: false
  },
  {
    id: 4,
    route: '/configuracoes-de-usuarios/permissoes-de-usuario',
    icon: 'security',
    description: 'Permissões de Usuários',
    hash: 'HOME_PERMISSIONS_LINK',
    onlyAssociated: true
  },
  {
    id: 5,
    route: '/auditoria/auditoria-de-usuarios',
    icon: 'face',
    description: 'Auditoria de Usuários',
    hash: 'HOME_USER_AUDIT',
    onlyAssociated: true
  },
  {
    id: 6,
    route: '/auditoria/auditoria-de-dados',
    icon: 'fact_check',
    description: 'Auditoria de Dados',
    hash: 'HOME_DATA_AUDIT',
    onlyAssociated: true
  },
  {
    id: 7,
    route: '',
    icon: 'logout',
    description: 'Sair',
    hash: 'dev',
    onlyAssociated: false
  },
]
